import React, { useState } from "react";
import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import { useParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import usePatchHook from "../../customHooks/usePatchHook";

const EditColumnDefinition = loadable(
  () => import("../../components/ColumnDefinition/EditColumnDefinition")
);

const EditColumn = () => {
  const { slug } = useParams();
  const [isopenWarningPopup, setIsOpenWarningPopup] = useState(false);

  const { data: templateData, isLoading } = useGetHook({
    queryKey: [`column-${slug}`],
    url: `${APIS.COLUMN_DEFINITION_RESET}${slug}/`,
    params: {},
  });

  const { mutateAsync: Resetmutateasync } = usePostHook({
    queryKey: ["reset"],
  });

  const { mutateAsync, isLoading: isPatchloading } = usePatchHook({
    queryKey: [`column-${slug}`],
  });

  const handleReset = async () => {
    const url = `${APIS.COLUMN_DEFINITION_RESET}${slug}/reset-to-default/`;
    try {
      const res = await Resetmutateasync({ url, formData: {} });
      if (res?.status === 200) {
        setIsOpenWarningPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleEdit = async (values: any, setError: any) => {
    let finalPayload: any = {
      name: values.name,
      slug: values.slug,
    };

    try {
      finalPayload.excelLayout = JSON.parse(values.layout);
    } catch (err) {
      console.error("Invalid JSON format in editor");
      finalPayload.layout = values.layout;
    }

    const url = `${APIS.COLUMN_DEFINITION_RESET}${slug}/`;
    try {
      await mutateAsync({ url, formData: finalPayload, setError });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit {slug?.replace(/[-_]/g, " ")}
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditColumnDefinition
          templateData={templateData}
          handleEdit={handleEdit}
          handleReset={handleReset}
          setIsOpenWarningPopup={setIsOpenWarningPopup}
          isopenWarningPopup={isopenWarningPopup}
          isPatchLoading={isPatchloading}
        />
      )}
    </>
  );
};

export default EditColumn;
